import angular from 'angular';
import _ from 'lodash';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        console.log(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            this.onSubmit({model: data});
        });
    }

    cancel() {
        this.onCancel();
    }

    getFields(){
        return {
            pnb: {
                key: 'pnb',
                type: 'hInput',
                templateOptions: {
                    label: 'Poštanski broj'
                }
            },

            naziv: {
                key: 'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv'
                }
            }
        };
    }
}

FormController.$inject = ['Grad'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/grad/form/form.controller.js